import { z } from "zod";

export const ChecklistServicoAmbienteCadastroSchema = z.object({
    idChecklistServico: z.number().int().optional(),
    ordem: z.coerce.string().nonempty({ message: "A ordem é obrigatória." }),
    descricao: z.string().nonempty({ message: "A descrição é obrigatória." }),
});

export type ChecklistServicoAmbienteCadastroForm = z.infer<typeof ChecklistServicoAmbienteCadastroSchema>;

export const defaultChecklistServicoAmbienteCadastroForm: Partial<ChecklistServicoAmbienteCadastroForm> = {
    idChecklistServico: undefined,
    ordem: '',
    descricao: '',

};
